<template>
    <two-columns v-if="realworksContactInformation">
        <data-group v-if="realworksContactInformation.bedrijfsNaam">
            <data-label>Bedrijfsnaam</data-label>
            <data-value>{{ realworksContactInformation.bedrijfsNaam }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.kvkNummer">
            <data-label>KVK-nummer</data-label>
            <data-value>{{ realworksContactInformation.kvkNummer }}</data-value>
        </data-group>

        <data-group>
            <data-label>Relatiesoort</data-label>
            <data-value>{{ realworksContactInformation.relatieSoort }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.nationaliteit">
            <data-label>Nationaliteit</data-label>
            <data-value>{{ flagIcon }} {{ realworksContactInformation.nationaliteit }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.geboorteDatum">
            <data-label>Geboortedatum</data-label>
            <data-value>{{ formatDate(realworksContactInformation.geboorteDatum) }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.relatieCode">
            <data-label>Relatiecode</data-label>
            <data-value>{{ realworksContactInformation.relatieCode }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.accountManagerNaam" style="grid-column: 1 / span 2;">
            <data-label>Accountmanager</data-label>
            <data-value>{{ realworksContactInformation.accountManagerNaam }}</data-value>
        </data-group>

        <data-group v-if="realworksContactInformation.tokenNaam" style="grid-column: 1 / span 2;">
            <data-label>Binnengekomen via token</data-label>
            <data-value>
                <span>{{ realworksContactInformation.tokenNaam }}</span>

                <template v-if="realworksContactInformation.createdAt">
                    <span> op datum: {{ formatDate(realworksContactInformation.createdAt) }}</span>
                </template>
            </data-value>
        </data-group>

        <data-group v-if="hasKenmerken" style="grid-column: 1 / span 2;">
            <data-label>Kenmerken</data-label>
            <data-value>
                <chip-container>
                    <chip-label
                        v-for="kenmerk in realworksContactInformation.kenmerken"
                        :key="kenmerk.id"
                    >
                        {{ kenmerk.omschrijving }}
                    </chip-label>
                </chip-container>
            </data-value>
        </data-group>
    </two-columns>
</template>

<script setup lang="ts">
    import flags from '@/utils/flags';
    import TwoColumns from '@components/UI/TwoColumns.vue';
    import type { Contact } from '@keyvue/one-api-client';
    import { DataGroup, DataLabel, DataValue, ChipContainer, ChipLabel } from '@keyvue/one-ui';
    import { computed, inject, type Ref } from 'vue';
    import { formatDate } from '@/utils/date';

    interface RealworksContactInformation {
        relatieSoort: string
        nationaliteit: string
        geboorteDatum: Date
        relatieCode: string | null
        accountManagerNaam: string
        tokenNaam: string | null
        kenmerken: Array<{ id: number, bedrijfcode: string, groep: string, omschrijving: string, actief: boolean }>
        bedrijfsNaam: string | null
        kvkNummer: string | null
        createdAt: Date | null
        updatedAt: Date | null
    }

    const contact = inject<Contact>('contact');
    if (!contact) throw new Error('contact is not provided');

    const realworksContactInformation = inject<Ref<RealworksContactInformation>>('realworksContactInformation');
    if (!realworksContactInformation) throw new Error('realworksContactInformation is not provided');

    const flagIcon = computed(() => flags.forAddress(contact.address));
    const hasKenmerken = computed(() => {
        if (!realworksContactInformation.value.kenmerken) {
            return false;
        }

        return Object.keys(realworksContactInformation.value.kenmerken).length > 0;
    });
</script>
